import { Component, computed, input } from "@angular/core";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { UserRoleItem } from "@src/app/core/components/user-menu-toggle/user-menu-toggle.component.model";

@Component({
    selector: 'cs-user-menu-toggle',
    templateUrl: './user-menu-toggle.component.html',
    imports: [LayoutModule]
})
export class UserMenuToggleComponent {
  public readonly userRoleList = input.required<UserRoleItem[]>();
  public readonly isThereAdminRole = computed(() => this.userRoleList().some(item => item.isAdmin));

  public readonly userRoleToggleSettings = computed(() => {
    return {
      title: `Roles (${this.userRoleList()?.length})`,
      adminRoleItems: this.userRoleList().sort((a, b) => Number(a.isAdmin) - Number(b.isAdmin)).filter(item => item.isAdmin) || [],
      simpleRoleItems: this.userRoleList().filter(item => !item.isAdmin) || []
    }
  });
}